<section class="row alinhamento-centralizado-tablet-grande" id="top-form">
  <div class="col-12">
    <div class="">
      <div class="latest-blog-loop">
        <ng-container>
          <mat-horizontal-stepper
            [selectedIndex]="getStepIndexFromEnum(stepAtual)"
            [linear]="isLinear"
            #stepper>
            <!-- Passo 1 - Cadastro -->
            <mat-step [label]="'CADASTRO' + quizEnum.CADASTRO">
              <div>
                <div class="card-block text-center bg-white">
                  <div>
                    <img
                      class="img-geia-top image-main logo-geia"
                      src="../../../../assets/app-assets/images/logo/logo-b-geia.png" />
                  </div>
                </div>
                <!-- Cadastro -->
                <div>
                  <div class="text-center pb-1 bg-white">
                    <h3 class="title-banner title preto-geia">DESCUBRA</h3>
                    <h3 class="sub-title-banner title ">SUA IDADE DE VITALIDADE</h3>
                  </div>
                  <div>
                    <div class="altura-div blank-page">
                      <div class="text-center container">
                        <div class="container__heading form-cadastro" style="padding-top: 10px">
                          <!-- Formulário de Cadastro -->
                          <div class="row">
                            <div class="colunas col-xs-12 col-sm-12 col-md-12 col-lg-12">
                              <div class="row mt-2">
                                <form [formGroup]="formQuiz" class="w-100">
                                  <div class="col-12 col-sm-12">
                                    <div class="form-group row">
                                      <!-- Nome -->
                                      <div class="form-group mb-1 col-sm-12 col-md-12" style="text-align: justify">
                                        <input
                                          (ngModelChange)="onFieldChange()"
                                          type="text"
                                          class="form-control round"
                                          id="name"
                                          maxlength="250"
                                          formControlName="name"
                                          placeholder="Nome Completo"
                                          [ngClass]="{
                                            'is-invalid': formQuiz.controls['name'].errors && isFormSubmited
                                          }" />
                                        <app-validacao-form-input
                                          [nomeFormulario]="formQuiz"
                                          nomeCampo="name"
                                          [maxLength]="250"
                                          [minLength]="10"
                                          [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                                      </div>
                                      <!-- E-mail -->
                                      <div class="form-group mb-1 col-sm-12 col-md-12" style="text-align: justify">
                                        <input
                                          type="text"
                                          class="form-control round"
                                          id="email"
                                          placeholder="E-mail"
                                          formControlName="email"
                                          [maxlength]="249"
                                          (ngModelChange)="onFieldChange()"
                                          required
                                          [ngClass]="{
                                            'is-invalid': formQuiz.controls['email'].errors && isFormSubmited
                                          }" />
                                        <app-validacao-form-input
                                          [nomeFormulario]="formQuiz"
                                          nomeCampo="email"
                                          [maxLength]="250"
                                          [minLength]="5"
                                          [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                                        <div
                                          class="errors"
                                          *ngIf="
                                            formQuiz.get('email')?.invalid &&
                                            (formQuiz.get('email')?.touched || formQuiz.get('email')?.dirty)
                                          ">
                                          <div class="errors" *ngIf="formQuiz.get('email')?.hasError('checkEmail')">
                                            {{ formQuiz.get('email')?.errors?.['checkEmail'] }}
                                          </div>
                                        </div>
                                      </div>
                                      <!-- Idade -->
                                      <div class="form-group mb-1 col-sm-12 col-md-12" style="text-align: justify">
                                        <input
                                          type="text"
                                          class="form-control round"
                                          id="age"
                                          formControlName="age"
                                          placeholder='Idade'
                                          [maxlength]="3"
                                          (ngModelChange)="onFieldChange()"
                                          required
                                          [ngClass]="{
                                            'is-invalid': formQuiz.controls['age'].errors && isFormSubmited
                                          }" />
                                        <app-validacao-form-input
                                          [nomeFormulario]="formQuiz"
                                          nomeCampo="age"
                                          [maxLength]="3"
                                          [minLength]="1"
                                          [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                                      </div>
                                      <!-- Sexo -->
                                      <div class="form-group mb-1 col-md-12 col-sm-12" style="text-align: justify">
                                        <ng-select
                                          class="round shadow"
                                          formControlName="sex"
                                          placeholder="Sexo"
                                          id="sex"
                                          [multiple]="false"
                                          [searchable]="false"
                                          [loading]="false"
                                          [closeOnSelect]="true"
                                          [ngClass]="{
                                            'campo-obrigatorio': formQuiz.controls['sex'].errors && isFormSubmited
                                          }">
                                          <ng-option [value]="1">Masculino</ng-option>
                                          <ng-option [value]="2">Feminino</ng-option>
                                        </ng-select>
                                        <app-validacao-form-input
                                          [nomeFormulario]="formQuiz"
                                          nomeCampo="sex"
                                          [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                                      </div>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                          <!-- Botão -->
                          <div class="button-mobile w-100">
                            <div class="col-sm-12">
                              <button
                                class="btn-simule btn btn-outline-secondary btn-min-width"
                                (click)="onCadastrar()">
                                INICIAR
                              </button>
                            </div>
                          </div>
                          <!-- Img Rodapé -->
                          <div class="cadastro-people">
                            <img
                              class="cadastro-people-image"
                              src="./../../../../assets/app-assets/images/quiz-teste-vitalidade/cadastro/todos de todos@2x.png"
                              alt="todas as pessoas" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </mat-step>
            <!-- Passo 2 - Perguntas -->
            <mat-step [label]="'PERGUNTAS' + quizEnum.PERGUNTAS">
              <div class="quiz-question-step">
                <!-- Barra de Progresso -->
                <div
                  class="progress-bar-container"
                  role="progressbar"
                  [attr.aria-valuenow]="progressoPercentual"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  [attr.aria-label]="'Progresso: ' + progressoPercentual + '%'">
                  <div class="progress-bar" [style.width.%]="progressoPercentual"></div>
                  <span class="progress-text" aria-hidden="true">{{ progressoPercentual }}%</span>
                </div>
                <h3 class="preto-geia pergunta">{{ perguntaAtual.description }}</h3>
                <div class="question-options">
                  <label
                    *ngFor="let resposta of respostasPerguntaAtual"
                    class="question-option"
                    [for]="'pergunta-' + perguntaAtual.order + '-resposta-' + resposta.order">
                    <img class="question-option-image" [src]="resposta.img" [alt]="resposta.description" />
                    <input
                      class="question-option-input"
                      type="radio"
                      [id]="'pergunta-' + perguntaAtual.order + '-resposta-' + resposta.order"
                      [name]="'pergunta-' + perguntaAtual.order"
                      [value]="resposta.score"
                      (change)="onFieldChange(); onChangeRespostaQuiz(perguntaAtual, resposta)" />
                    <span class="question-option-caption">
                      <span class="question-option-indicator" aria-hidden="true"></span>
                      <span>{{ resposta.description }}</span>
                    </span>
                  </label>
                </div>
              </div>
            </mat-step>
            <!-- Passo 3 - Resultado -->
            <mat-step [label]="'RESULTADO' + quizEnum.RESULTADO">
              <div class="vitality-result-page" *ngIf="resultado as dadosResultado">
                <div class="vitality-result" #resultadoCompartilhavel>
                  <header class="vitality-result-header">
                    <div class="card-block text-center">
                      <div>
                        <img
                          class="img-geia-top image-main logo-geia"
                          src="../../../../assets/app-assets/images/logo/logo-b-geia.png" />
                      </div>
                    </div>
                    <h3 class="title-banner title preto-geia">SEU RESULTADO</h3>
                    <h3 class="sub-title-banner title">CHEGOU!</h3>
                  </header>

                  <main>
                    <div class="vitality-result-summary" aria-label="Resumo do resultado">
                      <div class="vitality-result-avatar">
                        <img
                          [src]="imagemResultado"
                          [alt]="dadosResultado.sexDescription + ', ' + dadosResultado.avatarCategoryDescription" />
                      </div>

                      <div class="vitality-result-details">
                        <div class="vitality-age">
                          <h3><b>SUA IDADE DE VITALIDADE É</b></h3>
                          <strong>{{ dadosResultado.vitalityAge }} ANOS</strong>
                        </div>
                        <span
                          class="vitality-status"
                          [class.is-positive]="
                            dadosResultado.status === 1 ||
                            dadosResultado.statusDescription.toLocaleLowerCase('pt-BR').includes('positivo')
                          "
                          >{{ dadosResultado.statusDescription }}</span
                        >

                        <div class="vitality-message">
                          <img src="assets/app-assets/images/quiz-teste-vitalidade/icons/Grupo 1.svg" alt="" />
                          <p class="preto-geia" style="font-size: 1rem">{{ dadosResultado.message }}</p>
                        </div>
                      </div>
                    </div>

                    <div
                      class="vitality-age-difference mt-2"
                      [class.is-above]="
                        dadosResultado.differenceTypeDescription.toLocaleLowerCase('pt-BR') === 'acima'
                      ">
                      {{ dadosResultado.ageDifference }} ANOS
                      {{ dadosResultado.differenceTypeDescription | uppercase }} DA SUA IDADE
                    </div>

                    <p class="vitality-chronological-age preto-geia">
                      SUA IDADE INFORMADA:
                      <b>{{ dadosResultado.chronologicalAge }} ANOS.</b>
                    </p>

                    <p class="vitality-disclaimer">{{ dadosResultado.disclaimer }}</p>

                    <section class="vitality-final-message">
                      <img
                        class="vitality-share-icon"
                        src="assets/app-assets/images/quiz-teste-vitalidade/icons/Grupo 3.svg"
                        alt="" />
                      <button
                        class="vitality-share-button"
                        type="button"
                        aria-label="Compartilhar resultado"
                        (click)="compartilharResultado()">
                        <img
                          class="vitality-share-action"
                          src="assets/app-assets/images/quiz-teste-vitalidade/icons/Grupo 11.svg"
                          alt="" />
                      </button>
                      <div style="font-size: 1rem" [innerHTML]="dadosResultado.finalMessage"></div>
                    </section>
                  </main>
                </div>
              </div>
            </mat-step>
          </mat-horizontal-stepper>
        </ng-container>
      </div>
    </div>
  </div>
</section>
